export const CHATBOT_USER       = 'chatbot_user';
export const SAVE_MESSAGE       = 'save_message';
export const SAVE_MANAGE_CODE   = 'save_manage_code';
export const CHATBOT_LOGIN      = 'chatbot_login';
export const SAVE_TIME          = 'save_time';
export const SAVE_APPLY_LIST    = 'save_apply_list';
export const DELETE_APPLY_LIST = 'delete_apply_list';
export const SAVE_APPLY_CANCEL_LIST = 'save_apply_cancel_list'
export const DELETE_APPLY_CANCEL_LIST = 'delete_apply_cancel_list'
export const SAVE_TEXT                  = 'save_text'
export const GET_WELCOME_LIST                  = 'get_welcome_list'

export const LOGIN_USER                  = 'login_user'
export const AUTH_USER                  = 'auth_user'
export const LOGOUT_USER                  = 'logout_user'

